module.exports = __webpack_public_path__ + "img/prt0002.prt.574ae7ea.jpg";